import { Tuple } from '../../../types';
import { textMandatory, maxLength, matchAlphanumericExtended, isNameUnique } from '../../validationFunctions';
import * as validatorRules from '../../validatorRules.json';
import { interpolateValidationRule } from '../../validatorMessages';
import { SupportingActivityItemModel } from '../../../api/models';

const nameValidator = (values: Partial<SupportingActivityItemModel>): Tuple<(value: any) => boolean, string>[] => {
    return [
        [textMandatory, validatorRules.BR1_Mandatory_Field.FieldMessage],
        [maxLength(250), interpolateValidationRule(validatorRules.BR3_Maximum_Field_Length, [], ['250'])],
        [
            matchAlphanumericExtended,
            interpolateValidationRule(validatorRules.BR12_AlphaNumeric_Extended, [['PropertyName', `Name for this supporting R&D activity`]], []),
        ],
        [
            value =>
                isNameUnique(value, values.allOtherSubActivitiesForThisApp),
            interpolateValidationRule(validatorRules.BR80_Project_and_Activity_Names_Unique_Per_Application, [],
                ['supporting R&D activity', 'supporting R&D activity']),
        ],
        [
            value =>
                isNameUnique(value, values.allOtherSubActivitiesForThisOrganisation),
            interpolateValidationRule(validatorRules.BR80_02_Activity_SubActivity_Names_Unique_Per_Org, [],
                ['supporting R&D activity', 'supporting R&D activity']),
        ],
    ];
};

export default nameValidator;
